<template>
  <page>
    <page-header-new :title="pageTitle" :breadcrumbs="pageBreadcrumbs">
    </page-header-new>
    <page-content>
      <form-section
        :title="$t('WebFont_Title')"
        :description="$t('WebFont_Description')"
      >
        <template slot="controls">
          <el-button
            v-if="$can('WebFont:FullAccess')"
            type="primary"
            icon="el-icon-circle-plus-outline"
            @click="create"
          >
            {{ $t('WebFont_Form_CreateButton') }}
          </el-button>
        </template>
        <rest-list-editable
          :payload="fetchWebFontEndpoint"
          :rules="rules"
          :add-endpoint="addEndpoint"
          :update-endpoint="updateEndpoint"
          :show-header="true"
          :filterable="false"
          :outline="false"
          ref="rest-list-editable"
        >
          <rest-list-column
            :editable="true"
            prop="name"
            :title="$t('WebFont_FontName')"
          />
          <rest-list-column
            :editable="true"
            prop="family"
            :title="$t('WebFont_FontFamily')"
          />
          <rest-list-column
            :editable="true"
            prop="url"
            :title="$t('WebFont_FontUrl')"
          />
          <rest-list-column-actions
            v-if="$can('WebFont:FullAccess')"
            :editable="true"
          >
            <template slot-scope="scope">
              <rest-list-action-delete
                :endpoint="rowDeleteEndpoint(scope.row)"
                :name="scope.row.name"
              />
            </template>
          </rest-list-column-actions>
        </rest-list-editable>
      </form-section>
    </page-content>
  </page>
</template>

<script>
import PageHeaderNew from '@/common/components/page/PageHeaderNew'
import Page from '@/common/components/page/Page'
import PageContent from '@/common/components/page/PageContent'
import { projectEndpoint } from '@/core/helpers'
import FormSection from '@/common/components/form/FormSection'
import RestListEditable from '@/common/components/rest/RestListEditable'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnActions from '@/common/components/rest/RestListColumnActions'
import RestListActionDelete from '@/common/components/rest/RestListActionDelete'

export default {
  components: {
    RestListActionDelete,
    RestListColumnActions,
    RestListColumn,
    RestListEditable,
    FormSection,
    PageContent,
    Page,
    PageHeaderNew
  },

  methods: {
    addEndpoint() {
      return projectEndpoint({
        method: 'post',
        url: `web-font`
      })
    },
    updateEndpoint(row) {
      return projectEndpoint({
        method: 'patch',
        url: `web-font/${row.id}`
      })
    },
    rowDeleteEndpoint(row) {
      return projectEndpoint({
        method: 'delete',
        url: `web-font/${row.id}`
      })
    },
    create() {
      this.$refs['rest-list-editable'].addRow({
        name: '',
        url: '',
        family: ''
      })
    },
    validFontFamily(rule, value, callback) {
      let inQuotes = false
      let quoteChar = ''

      for (let i = 0; i < value.length; i++) {
        if (!inQuotes && (value.charAt(i) === '"' || value.charAt(i) === "'")) {
          inQuotes = true
          quoteChar = value.charAt(i)
        } else if (
          inQuotes &&
          value.charAt(i) === quoteChar &&
          value.charAt(i - 1) !== '\\'
        ) {
          inQuotes = false
          quoteChar = ''
        }
      }

      if (inQuotes) {
        callback(new Error())
      } else {
        callback()
      }
    },
    validCssUrl(rule, value, callback) {
      try {
        let url = new URL(value)
        if (url.protocol === 'https:') {
          callback()
        } else {
          callback(new Error())
        }
      } catch (error) {
        callback(new Error())
      }
    }
  },
  computed: {
    fetchWebFontEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `web-font`,
        params: {}
      })
    },
    rules() {
      return {
        name: [
          {
            required: true,
            message: this.$t('WebFont_validation_FontName_Required')
          },
          {
            pattern: /^[a-z0-9 ]+$/i,
            message: this.$t('WebFont_validation_FontName_Alphanumeric')
          }
        ],
        family: [
          {
            required: true,
            message: this.$t('WebFont_validation_FontFamily_Required')
          },
          {
            pattern: /^[a-z0-9 "',-\\]+$/i,
            message: this.$t('WebFont_validation_FontFamily_Alphanumeric')
          },
          {
            validator: this.validFontFamily,
            message: this.$t('WebFont_validation_FontFamily_InvalidQuotes')
          }
        ],
        url: [
          {
            required: true,
            message: this.$t('WebFont_validation_FontUrl_Required')
          },
          {
            validator: this.validCssUrl,
            message: this.$t('WebFont_validation_FontUrl_Valid'),
            trigger: 'blur'
          }
        ]
      }
    },
    pageTitle() {
      return this.$t(this.$route.meta.title)
    },

    pageBreadcrumbs() {
      return [
        {
          label: this.$t('Settings_Breadcrumb_Settings')
        },
        {
          label: this.$t('LeftNavigation_Advanced')
        },
        {
          label: this.$t('WebFont_Title')
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/settings/pages/WebFontSettingsPage.vue